import { ReferentialDto, ReferentialKey } from "api/referential";
import { GuarantorDto } from "api/tenant";
import { TenantFormFieldNames } from "../types/tenantFormFieldNames";
import { TenantGuarantorFormValues } from "../types/tenantGuarantorFormValues";

export const mapTenantGuarantorFormValues = (
  formValues: TenantGuarantorFormValues,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>,
): GuarantorDto => {

  const findReferentialId = (referentialType: ReferentialKey, code: string): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.code === code);
    return item?.id || '';
  };

  const mapIncomes = () => {
    const incomes = formValues[TenantFormFieldNames.Incomes]
    return incomes.map((income) => ({
      incomeTypeId: findReferentialId(ReferentialKey.IncomeType, income.incomeType),
      value: income.amount
    }))
  }

  const createAddress = () => ({
    line1: formValues.address,
    line2: '',
    line3: formValues.additionalAddress || undefined,
    zipCode: formValues.postalCode,
    city: formValues.city,
    country: formValues.country,
    formattedAddress: `${formValues.address},${formValues.city},${formValues.country}`,
    latitude: formValues.latitude || undefined,
    longitude: formValues.longitude || undefined,
    googlePlaceId: formValues.googlePlaceId || undefined
  });

  return {
    id: formValues['id'] || undefined,
    lastName: formValues[TenantFormFieldNames.LastName],
    firstName: formValues[TenantFormFieldNames.FirstName],
    // Date calendaire : string "yyyy-MM-dd" du picker de bout en bout
    birthDate: formValues[TenantFormFieldNames.BirthDate],
    phone: formValues[TenantFormFieldNames.Phone],
    email: formValues[TenantFormFieldNames.Email],
    civilityId: findReferentialId(ReferentialKey.Civility, formValues[TenantFormFieldNames.Civility]),
    employmentStatusId: findReferentialId(ReferentialKey.EmploymentStatus, formValues[TenantFormFieldNames.ProfessionalSituation]),
    isGuarantor: true,
    incomes: mapIncomes(),
    address: createAddress()
  };
};

